import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "use-debounce";
import { usePluginConfig } from "../../contexts/pluginContext";
import EventSearch from "../../services/EventSearch";

const DEBOUNCE_TIME = 300;

export function useEventSearch(searchParams, context) {
	const pluginConfig = usePluginConfig();
	const eventSearch = new EventSearch({ context: context, pluginConfig });
	const debouncedSearchTerm = useDebounce(
		searchParams.searchTerm,
		DEBOUNCE_TIME,
	);
	const searchFn = () => {
		return eventSearch.search({
			searchTerm: searchParams.searchTerm,
			hitsPerPage: searchParams.hitsPerPage || 3,
		});
	};

	const query = { ...context.query };
	delete query.query;

	return useQuery({
		// When searchTerm change, this query will refetch
		queryKey: ["eventSearch", JSON.stringify(query), debouncedSearchTerm],
		enabled: !!searchParams.searchTerm,
		queryFn: searchFn,
		staleTime: Infinity,
	});
}
